/**
 * Default coming-soon settings used when nothing has been written to the
 * SiteContent table yet. Launch date is May 22 2026 · 9:30 PM Africa/Kampala
 * (UTC+3) which equals 18:30 UTC.
 */
export const SITE_SETTINGS_DEFAULT = {
    mode: "coming-soon",
    launchAt: "2026-05-22T18:30:00.000Z",
    announcementEnabled: true,
    announcementTitle: "IMPORTANT ANNOUNCEMENT",
    announcementBody: "This Friday's overnight is cancelled. Our next gathering is in October at a new venue — more details soon. We can't wait to worship together again.",
};
export const FOOTER_SETTINGS_DEFAULT = {
    copyright: "© 2026 Together In Heaven · Kampala, Uganda",
    verse: '"Let everything that has breath praise the Lord." — Ps. 150:6',
};
export const LIVE_CONTENT = {
    isLive: false,
    current: null,
    last: {
        youtubeId: "2Z4UlpSdAHE",
        title: "Together In Heaven · Worship Overnight",
        subtitle: "Dorothy Ashaba & the Upper Room Band — full overnight replay",
        streamedAt: null,
    },
};
export const EVENT_CONTENT = {
    date: "2026-05-22T18:30:00Z",
    doors: "9:00 PM",
    duration: "8 Hours",
    venue: {
        name: "Thobani Center",
        address: "2nd Floor · Thobani Center, Nakasero, Kampala, Uganda",
        coords: "0°18′51″N  32°34′53″E",
    },
    cards: [
        { num: "01", k: "Doors", v: "9:00 PM", note: "Arrive early — seating is first come." },
        { num: "02", k: "Entry", v: "Free", note: "An offering will be taken for the ministry." },
        { num: "03", k: "Duration", v: "8 Hours", note: "Continuous worship through the night." },
        { num: "04", k: "Stream", v: "Worldwide", note: "Join from anywhere. Free to watch." },
    ],
    program: [
        { time: "9:30 PM", title: "Gathering & Opening Prayer", note: "Led by the Pastoral team" },
        { time: "10:00 PM", title: "First Set — Songs of Ascent", note: "Dorothy & the Upper Room Band" },
        { time: "11:30 PM", title: "The Word", note: "A short, steady reading" },
        { time: "12:00 AM", title: "Second Set — Deep Waters", note: "Intercession & spontaneous worship" },
        { time: "2:00 AM", title: "The Quiet Hour", note: "Acoustic · candlelight · stillness" },
        { time: "3:00 AM", title: "Third Set — Victory & Jubilee", note: "Full band, loud and glad" },
        { time: "4:30 AM", title: "Communion", note: "Served slowly, together" },
        { time: "5:00 AM", title: "Sunrise Benediction", note: "A blessing for the road home" },
    ],
    timeline: [
        {
            year: "2019",
            title: "First Overnight",
            body: "Thirty friends in a small upper room above a bakery. One keyboard, one mic, one long night. The name was written over the door in chalk.",
        },
        {
            year: "2021",
            title: "The First Album",
            body: "\"Upper Room Vol. 1\" recorded live over seven hours. Eleven songs, no overdubs, one offering.",
        },
        {
            year: "2023",
            title: "A Ministry Grows",
            body: "Monthly gatherings begin at Thobani Center. The livestream finds listeners in Nairobi, Lagos, Houston, London.",
        },
        {
            year: "2026",
            title: "This Night",
            body: "The largest overnight yet — and one that will also be recorded for \"Upper Room Vol. 3.\" You are invited into the room.",
        },
    ],
    venueDl: [
        { k: "Address", v: "2nd Floor · Thobani Center · Nakasero, Kampala" },
        { k: "Parking", v: "Free on-site · overflow on Kyaggwe Rd." },
        { k: "Accessibility", v: "Elevator to 2nd floor · wheelchair seating reserved" },
        { k: "Food", v: "Hot tea & mandazi served at 2 AM" },
    ],
};
//# sourceMappingURL=content.js.map